import { takeEvery, all } from "redux-saga/effects";
import { tourStartedAction, restartGuideAction } from "./actions";
import { Action } from "redux";
import { TOURS_LOCAL_STORAGE_KEY } from "./selector";
import { getTourConfigRequest } from "@common";

export function* tourSaga() {
    yield all([
        loadTourConfig(),
        takeEvery((a: Action) => tourStartedAction.is(a), function(a: typeof tourStartedAction.typeInterface) {
            const value = localStorage.getItem(TOURS_LOCAL_STORAGE_KEY);
            const viewedTours = value ? (JSON.parse(value) as string[]) : [];

            if (viewedTours.indexOf(a.tour) === -1) {
                viewedTours.push(a.tour);
                localStorage.setItem(TOURS_LOCAL_STORAGE_KEY, JSON.stringify(viewedTours));
            }
        }),
        takeEvery(restartGuideAction.type, restartGuide)
    ]);
}

function* loadTourConfig() {
    try {
        yield* getTourConfigRequest.saga({});
    } catch (e) {
        console.error("Error loading tour configuration", e);
    }
}

function restartGuide() {
    localStorage.removeItem(TOURS_LOCAL_STORAGE_KEY);
    location.reload();
}
